import { render, staticRenderFns } from "./ResetPasswordModal.vue?vue&type=template&id=50c05830"
import script from "./ResetPasswordModal.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports